import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import vi from "./locales/vi.json";
import ja from "./locales/ja.json";
import { LANGUAGES, type Lang } from "./types";

const STORAGE_KEY = "lumina_mkt_lang";

function loadInitialLang(): Lang {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && (LANGUAGES as readonly string[]).includes(v)) return v as Lang;
  } catch {
    /* ignore */
  }
  return "vi";
}

i18n.use(initReactI18next).init({
  resources: {
    vi: { translation: vi },
    en: { translation: en },
    ja: { translation: ja },
  },
  lng: loadInitialLang(),
  fallbackLng: "vi",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
export { LANGUAGES, type Lang } from "./types";
